"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.concat.js");
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _FemaGoTable = _interopRequireDefault(require("./tables/femaGoTable/FemaGoTable"));
var _lodash = _interopRequireDefault(require("lodash"));
var _utils = require("../../../common/requestDetails/v2/utils");
var _constants = require("../../../common/requestDetails/constants.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var requestSummaryTable = function requestSummaryTable(json) {
  var dynamicComponent = json.dynamicComponent,
    dataPath = json.dataPath,
    requestDetailsData = json.requestDetailsData,
    itemData = json.itemData,
    showByFundingStream = json.showByFundingStream;
  var aggregates = {
    aggregratedtotalCount: 0,
    aggregratedtotalCost: 0
  };
  var requestDetails = _lodash.default.values(_lodash.default.get(dynamicComponent, dataPath, requestDetailsData));
  var getitemdesc = function getitemdesc(itemCode) {
    var itemRefData = _lodash.default.values(_lodash.default.get(dynamicComponent, dataPath, itemData));
    var itemDetail = _lodash.default.find(itemRefData, function (item) {
      return item.itemCode === itemCode;
    });
    var name = _lodash.default.get(itemDetail, 'name');
    return name;
  };
  var renderTable = function renderTable(tableData) {
    var totals = 0;
    var title;
    var requestBody = tableData.objects.map(function (obj, index) {
      totals = (0, _utils.getTotalCountAndCost)(obj, aggregates);
      title = _lodash.default.get(tableData, "objectTitles.".concat(index), '');
      return /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Row, {
        key: index
      }, /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.TextCell, {
        width: 3
      }, title), /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.TextCell, {
        width: 3
      }, totals[0]), /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.TextCell, {
        width: 3
      }, totals[1]));
    });
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, requestBody, /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Row, null, /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.TextCell, null, /*#__PURE__*/_react.default.createElement("b", null, "Total")), /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.TextCell, {
      width: 3
    }, totals[2]), /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.TextCell, {
      width: 3
    }, totals[3])));
  };
  var showTable = function showTable(tableData) {
    aggregates.aggregratedtotalCount = 0;
    aggregates.aggregratedtotalCost = 0;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Header, {
      as: "h4"
    }, tableData.title, " "), /*#__PURE__*/_react.default.createElement(_FemaGoTable.default, {
      summary: "Grant request summary table - " + tableData.title
    }, /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Header, null, /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Row, null, /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.HeaderCell, null, tableData.cellHeader), /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.HeaderCell, null, "Number of items"), /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.HeaderCell, null, "Total cost"))), /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Body, null, renderTable(tableData))));
  };
  var showAsMutliTable = function showAsMutliTable() {
    var fundingStreamTables = [];
    var tableData = {};
    var activity, project;
    _lodash.default.forEach(requestDetails, function (obj) {
      tableData = {};
      tableData['objects'] = [];
      tableData['objectTitles'] = [];
      var fsType = obj.fundingStreamType;
      tableData['title'] = _lodash.default.get(_constants.FUNDING_STREAM_NAME, fsType, '');
      if (fsType === 'preAwardCosts') {
        tableData['cellHeader'] = 'Item';
      } else if (fsType === 'firePreventionAndSafety') {
        tableData['cellHeader'] = 'Activity – Project';
      } else if (fsType === 'researchAndDevelopment') {
        tableData['cellHeader'] = 'Project Name';
      }
      _lodash.default.forEach(_lodash.default.values(obj['children']), function (obj) {
        activity = getitemdesc(_lodash.default.get(obj, 'itemCode'));
        if (obj['children']) {
          _lodash.default.forEach(_lodash.default.values(obj['children']), function (obj) {
            if (fsType === 'researchAndDevelopment') {
              project = "".concat(_lodash.default.get(obj.additionalInformation, 'projectName', ''));
              tableData['objectTitles'].push(project);
            } else {
              project = "".concat(getitemdesc(_lodash.default.get(obj, 'itemCode')), " ").concat(_lodash.default.get(obj.additionalInformation, 'projectName', ''));
              tableData['objectTitles'].push(project ? activity + '-' + project : activity);
            }
            tableData['objects'].push(obj);
          });
        } else {
          tableData['objectTitles'].push(activity);
          tableData['objects'].push(obj);
        }
      });
      fundingStreamTables.push(showTable(tableData));
    });
    return fundingStreamTables;
  };
  var showAsSingleTable = function showAsSingleTable() {
    var tableData = {};
    tableData['title'] = 'Grant request summary';
    tableData['cellHeader'] = 'Activity';
    tableData['objects'] = [];
    tableData['objectTitles'] = [];
    _lodash.default.forEach(requestDetails, function (obj) {
      _lodash.default.forEach(_lodash.default.values(obj['children']), function (obj) {
        tableData.objectTitles.push(getitemdesc(_lodash.default.get(obj, 'itemCode')));
        tableData.objects.push(obj);
      });
    });
    return showTable(tableData);
  };
  return showByFundingStream ? showAsMutliTable() : showAsSingleTable();
};
var _default = requestSummaryTable;
exports.default = _default;